/* RK: gedrag van de gedeelde productkaart - kleurbolletjes, lazy-vangnet en
   de hover-foto.

   !! WAAROM DIT EEN LOS BESTAND IS - NIET TERUGZETTEN IN DE SNIPPET !!
   Dit stond als <script> in snippets/rk-card.liquid. Die snippet wordt per
   product gerenderd, dus stond ditzelfde blok van 11,6 kB 120 keer in de
   homepage. Gemeten: 120 blokken, samen 1.389 kB - bijna 40% van een
   HTML-document van 3,7 MB, en 118 van de 120 waren letterlijk identiek.
   Dat is tekst die een telefoon eerst helemaal moet binnenhalen en doorlezen
   voordat er iets op het scherm komt.
   Als los bestand haalt de browser het een keer op en onthoudt het daarna
   voor elke volgende pagina.

   Er staat bewust GEEN Liquid in dit bestand en dat moet zo blijven: een
   .js in assets wordt niet door Liquid gehaald. Alles wat per product
   verschilt reist mee als data-attribuut op de kaart zelf. */

(() => {
  /* Een keer per pagina geregistreerd, ongeacht hoe vaak dit bestand wordt
     ingeladen. Event delegation zoekt zelf de dichtstbijzijnde .rk-card op,
     dus elke kaart blijft onafhankelijk. */
  if (window.__rkCardSwatchInit) return;
  window.__rkCardSwatchInit = true;

  function activateSwatch(swatch) {
    const card = swatch.closest('.rk-card');
    if (!card) return;

    card.querySelectorAll('[data-rk-swatch]').forEach((el) => {
      el.classList.remove('is-active');
      el.setAttribute('aria-pressed', 'false');
    });
    swatch.classList.add('is-active');
    swatch.setAttribute('aria-pressed', 'true');

    const colorLabel = card.querySelector('[data-rk-card-color]');
    if (colorLabel) colorLabel.textContent = swatch.getAttribute('data-rk-color-name') || '';

    const swapImg = swatch.getAttribute('data-rk-swap-img');
    if (swapImg) {
      const img = card.querySelector('.rk-card__img--primary');
      if (img) {
        img.srcset = '';
        img.src = swapImg;
      }
    }
  }

  document.addEventListener('click', (e) => {
    const swatch = e.target.closest('[data-rk-swatch]');
    if (!swatch) return;
    e.preventDefault();
    e.stopPropagation();
    activateSwatch(swatch);
  });

  document.addEventListener('mouseover', (e) => {
    const swatch = e.target.closest('[data-rk-swatch]');
    if (!swatch) return;
    activateSwatch(swatch);
  });

  document.addEventListener('focusin', (e) => {
    const swatch = e.target.closest('[data-rk-swatch]');
    if (!swatch) return;
    activateSwatch(swatch);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    const swatch = e.target.closest('[data-rk-swatch]');
    if (!swatch) return;
    e.preventDefault();
    activateSwatch(swatch);
  });

  /* ---------------------------------------------------------------
     Vangnet voor foto's die door lazy loading nooit laden.
     Zie de uitleg bovenaan snippets/rk-card.liquid: gemeten, niet gegokt.
     Grijpt alleen in bij een foto die in beeld staat en dan nog steeds
     niet geladen is - een gewone lazy foto raakt hij niet aan, dus de
     winst van lazy loading blijft staan.
     --------------------------------------------------------------- */
  if (window.IntersectionObserver) {
    const revive = (img) => {
      if (img.complete && img.naturalWidth > 0) return;
      const src = img.getAttribute('src');
      if (!src) return;
      img.setAttribute('loading', 'eager');
      img.src = src;
    };

    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        /* Even wachten: staat de browser al te laden, dan is hij binnen
           deze tijd klaar en doen we niets. */
        window.setTimeout(() => revive(entry.target), 500);
      });
    }, { rootMargin: '200px' });

    const watch = () => {
      document.querySelectorAll('.rk-card__img--primary').forEach((img) => io.observe(img));
    };

    watch();
    window.setTimeout(watch, 1500);
    window.setTimeout(watch, 4000);
  }
})();

/* -----------------------------------------------------------------
   2e foto (hover-foto) pas ophalen bij een ECHTE hover.
   Eigen IIFE met een eigen vlag, los van __rkCardSwatchInit hierboven:
   die twee mogen elkaar nooit kunnen uitschakelen.
   ----------------------------------------------------------------- */
(() => {
  /* Een set listeners per pagina. In de thema-editor wordt een sectie
     telkens opnieuw gerenderd; zonder deze vlag stapelen de listeners zich
     op en loopt elke hover meerdere keren door dezelfde code. */
  if (window.__rkCardHoverInit) return;
  window.__rkCardHoverInit = true;

  /* Exact dezelfde voorwaarde als de hover-regel in assets/rk-card.css: kan
     de CSS de foto niet tonen, dan halen we hem ook niet op. Op een
     touchscreen gebeurt er dus niets. Bewust bij elk event opnieuw
     uitgelezen en niet een keer bij het laden - een laptop met touchscreen
     kan van invoermethode wisselen. */
  const hoverQuery = window.matchMedia
    ? window.matchMedia('(hover: hover) and (pointer: fine)')
    : null;
  const canHover = () => (hoverQuery ? hoverQuery.matches : true);

  const cardFrom = (target) => (target && target.closest ? target.closest('.rk-card') : null);

  function ensureHoverImage(card) {
    if (!card || card.__rkHoverImgDone) return;

    const src = card.getAttribute('data-rk-hover-src');
    if (!src) return; /* product zonder 2e foto: er valt niets te laden */

    const media = card.querySelector('.rk-card__media');
    if (!media) return;

    /* Vlag op het element zelf, niet op window: een kaart die later via de
       Section Rendering API binnenkomt is een nieuw element en begint dus
       gewoon opnieuw. */
    card.__rkHoverImgDone = true;
    if (media.querySelector('.rk-card__img--secondary')) return;

    const img = document.createElement('img');
    /* --pending houdt de opacity hard op 0 tot de foto binnen is; zonder die
       klasse zou de crossfade al beginnen terwijl het vak nog leeg is. */
    img.className = 'rk-card__img rk-card__img--secondary rk-card__img--pending';
    img.alt = '';
    img.decoding = 'async';

    /* ---------------------------------------------------------------
       HOE --pending ER WEER AF GAAT - GEMETEN BUG, NIET WEGHALEN.

       Hier stond eerst ALLEEN img.decode() als sein, met load/error als
       terugval voor browsers zonder decode(). Gemeten in Chrome: de foto
       was gewoon binnen (complete=true, naturalWidth=320) maar --pending
       bleef staan, en daarmee deed de hover helemaal niets meer.

       Twee dingen tegelijk mis:

       1. Die belofte van decode() loste NOOIT op - hij ketste ook niet af,
          want dan had de foutafhandeling de klasse er alsnog afgehaald.
          Het is een slang die in zijn eigen staart bijt: --pending zet
          opacity op 0 !important, dus de foto is volledig doorzichtig en
          de browser hoeft hem niet te decoderen. Precies die belofte moest
          --pending weghalen. Ook bij een ECHTE hover blijft dat hangen,
          want !important wint van de hover-regel.
       2. Omdat Chrome decode() heeft, werd de load-luisteraar in die oude
          opzet nooit eens aangehangen - hij zat in de else-tak.

       Daarom nu: load is het sein (die vuurt op het binnenhalen zelf en
       heeft niets met schilderen of decoderen te maken), decode() telt nog
       alleen mee als hij toevallig eerder klaar is, en er staat een noodrem
       op de tijd. Nooit meer iets vrijgeven laten afhangen van een bron.
       --------------------------------------------------------------- */
    let settled = false;
    let safety = 0;

    /* Mag uit elk van de wegen hieronder komen, ook meerdere keren. */
    const reveal = () => {
      if (settled) return;
      settled = true;
      if (safety) {
        window.clearTimeout(safety);
        safety = 0;
      }
      img.classList.remove('rk-card__img--pending');
    };

    const fail = () => {
      if (settled) return;
      /* Staat de foto er toch, dan tonen we hem alsnog. Anders het element
         weghalen, zodat de eerste foto blijft staan in plaats van een
         kapot-icoon. */
      if (img.complete && img.naturalWidth > 0) {
        reveal();
        return;
      }
      settled = true;
      if (safety) {
        window.clearTimeout(safety);
        safety = 0;
      }
      if (img.parentNode) img.parentNode.removeChild(img);
    };

    /* VOOR src/srcset: staat de foto al in de cache, dan is hij klaar
       voordat de regels hieronder draaien en vuurt load niet meer. */
    img.addEventListener('load', reveal, { once: true });
    img.addEventListener('error', fail, { once: true });

    const srcset = card.getAttribute('data-rk-hover-srcset');
    const sizes = card.getAttribute('data-rk-hover-sizes');
    const w = card.getAttribute('data-rk-hover-width');
    const h = card.getAttribute('data-rk-hover-height');
    if (w) img.setAttribute('width', w);
    if (h) img.setAttribute('height', h);
    /* sizes voor srcset: sommige browsers kiezen anders de verkeerde maat. */
    if (sizes) img.setAttribute('sizes', sizes);
    if (srcset) img.setAttribute('srcset', srcset);
    img.setAttribute('src', src);

    /* Als LAATSTE kind in het fotovak, precies waar de oude <img> stond: de
       CSS zet hem absoluut in datzelfde vak, dus geen verschuiving, en hij
       blijft boven de eerste foto liggen. */
    media.appendChild(img);

    /* Noodrem. Wat er ook hangt aan load of decode, na 3 seconden gaat
       --pending er hoe dan ook af: een fade die iets te vroeg begint is
       altijd beter dan een hover die niets doet. */
    safety = window.setTimeout(reveal, 3000);

    /* Cache-treffer: dan is de foto hierboven al klaar en komt er geen load
       meer. Een beeldje wachten, zodat de browser de opacity 0 eerst
       schildert - anders springt de foto erin zonder crossfade. */
    if (img.complete && img.naturalWidth > 0) {
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(reveal);
      } else {
        reveal();
      }
    }

    /* decode() is nog uitsluitend een OPTIMALISATIE: lost hij op, dan faden
       we op een al gedecodeerde foto. Blijft hij hangen of ketst hij af,
       dan gebeurt er niets en dekken load en de noodrem het af. Hier nooit
       meer fail() aanhangen: een afketsende decode zegt niets over of de
       foto er is. */
    if (typeof img.decode === 'function') {
      img.decode().then(reveal, () => {});
    }
  }

  /* Delegatie op document: de productrijen halen tabbladen achteraf op via
     de Section Rendering API, dus kaarten kunnen na het laden verschijnen.
     Deze ene listener vangt die nieuwe kaarten vanzelf mee; listeners per
     kaart zouden dat niet doen. pointerover bubbelt wel en pointerenter
     niet, dus dit is de delegeerbare variant. Hij vuurt vaker (ook bij elk
     kind), maar ensureHoverImage doet na de eerste keer niets meer. */
  if (window.PointerEvent) {
    document.addEventListener('pointerover', (e) => {
      /* Een vinger mag dit nooit starten: op touch is de 2e foto toch
         onzichtbaar, en dan is elke byte weggegooid. */
      if (e.pointerType === 'touch') return;
      if (!canHover()) return;
      ensureHoverImage(cardFrom(e.target));
    });
  } else {
    /* Oude browser zonder PointerEvent: dan mouseover, met dezelfde
       media-query als slot op de deur. */
    document.addEventListener('mouseover', (e) => {
      if (!canHover()) return;
      ensureHoverImage(cardFrom(e.target));
    });
  }

  /* Toetsenbord telt als hover - zie de :focus-visible regel in de CSS.
     Bewust ZONDER de hover-check: wie tabt heeft een toetsenbord, ook op
     een apparaat zonder muis. */
  document.addEventListener('focusin', (e) => {
    const card = cardFrom(e.target);
    if (!card) return;
    /* Alleen echte toetsenbordfocus. Een tik op mobiel geeft ook focusin en
       mag de foto niet ophalen. Een bolletje dat focus krijgt telt niet:
       dan staat de focus niet op de kaart zelf. */
    try {
      if (!card.matches(':focus-visible')) return;
    } catch (err) {
      /* Oude browser zonder :focus-visible - dan maar wel laden. */
    }
    ensureHoverImage(card);
  });
})();
